import axios from "axios";

// PATHS
const RA_DATA = '/network/ra/';
const SAVE_CLAIM = '/network/ra';

const fetchRaData = async (req: any): Promise<any> => {
    const response =  await axios.get(RA_DATA + req.id);
    return response.data;
}

const saveClaim = async (params: any): Promise<any> => {
    const response = await axios.post(SAVE_CLAIM, params);
    return response.data;
}

export {
    fetchRaData,
    saveClaim
}